import { render, staticRenderFns } from "./grid-validation-errors.vue?vue&type=template&id=1352d2bf&scoped=true&"
import script from "./grid-validation-errors.vue?vue&type=script&lang=js&"
export * from "./grid-validation-errors.vue?vue&type=script&lang=js&"
import style0 from "./grid-validation-errors.vue?vue&type=style&index=0&id=1352d2bf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1352d2bf",
  null
  
)

export default component.exports